import { env } from '@hum/common';

export const getUrlForConnectorsRedirection = () => {
  const actualUrl = `https://${env.CAPITAL_DOMAIN}`;
  return actualUrl;
};
